/** The inbox (src/notifications/): Schorschi's messages and replies, finished agent runs, todo assignments. */

import { useQuery } from "@tanstack/vue-query";
import { http } from "./client";

export interface Notification {
  id: string;
  source: "schorschi" | "agent" | "todos" | string;
  kind: string;
  title: string;
  bodyMd: string;
  link: string | null;
  data: Record<string, unknown> | null;
  fromId: string | null;
  fromName?: string | null;
  createdAt: string;
  readAt: string | null;
}

export const notificationKeys = { all: ["notifications"] as const };

export const useNotifications = () =>
  useQuery({ queryKey: notificationKeys.all, queryFn: () => http.get<{ items: Notification[]; unread: number }>("/api/v2/me/notifications", { limit: "40" }), staleTime: 30_000, refetchInterval: 120_000 });

export const markNotificationRead = (id: string) => http.post<{ marked: number }>(`/api/v2/me/notifications/${id}/read`);
export const markAllNotificationsRead = () => http.post<{ marked: number }>("/api/v2/me/notifications/read-all");
